import styled from 'styled-components'
import { Button } from '@mui/material'
import { CircularProgress } from '@mui/material'

interface Props {
  status: RequestStatus
  text: JSX.Element | string
  id?: string
}

export default function SaveButton({ status, text, id }: Props): JSX.Element {
  const elementId = id || Math.random().toString(36).substring(7)
  return (
    <StyledButton
      type="submit"
      variant="outlined"
      disabled={status === 'loading'}
      id={elementId}
      style={{
        background: elementId === 'unpublish' ? '#DC2626' : '#f3f4f6',
        color: elementId === 'unpublish' ? '#FFF' : '#098e4f',
      }}
    >
      {status === 'loading' ? <CircularProgress size={24} /> : text}
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  padding: var(--p-25, 8px) var(--p-4, 12px);
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: var(--rounded-xl, 12px);
  border: 1px solid var(--gray-100, #f3f4f6);
  text-transform: none;
  font-size: var(--size-sm, 14px);

  /* Shadow/xs */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
`
